// src/components/notifications/NotificationCenter.jsx
//
// Fixed, theme-aware stack of notifications, portaled to <body> so it floats
// above modals and the rest of the app.
//
// Accessibility: the two live-region hosts are ALWAYS mounted (even when empty)
// so a screen reader announces the very first message — a live region only
// announces content inserted *after* it already exists in the DOM. Errors and
// warnings go in an assertive region (they interrupt); info/success go in a
// polite region (they wait their turn).
import React from 'react';
import { createPortal } from 'react-dom';
import NotificationItem from './NotificationItem';
import '../../css/Notifications.css';

const isUrgent = (n) => n.type === 'error' || n.type === 'warning';

const NotificationCenter = ({ notifications, onDismiss, onClear }) => {
    if (typeof document === 'undefined') return null;

    const list = notifications || [];
    const urgent = list.filter(isUrgent);
    const calm = list.filter((n) => !isUrgent(n));

    return createPortal(
        <div className="qd-notif-region" aria-label="Notifications">
            {list.length > 1 && (
                <div className="qd-notif-toolbar">
                    <button type="button" className="qd-notif-clear" onClick={onClear}>
                        Clear all ({list.length})
                    </button>
                </div>
            )}
            <div className="qd-notif-stack" role="alert" aria-live="assertive">
                {urgent.map((n) => (
                    <NotificationItem key={n.id} notification={n} onDismiss={onDismiss} />
                ))}
            </div>
            <div className="qd-notif-stack" role="status" aria-live="polite">
                {calm.map((n) => (
                    <NotificationItem key={n.id} notification={n} onDismiss={onDismiss} />
                ))}
            </div>
        </div>,
        document.body
    );
};

export default NotificationCenter;
